var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Down Arrow"),React.createElement("path",{"fill":"#1F1C1A","fillRule":"evenodd","d":"M-1.36009065,6.81516171 C-2.53438373,5.64086863 -2.19215259,4.33790387 -0.587588551,3.90270953 L9.93415223,1.04897361 C11.5350864,0.614763765 12.4818879,1.55695091 12.0466936,3.16151495 L9.19295765,13.6832557 C8.75874781,15.2841899 7.45359402,15.6288464 6.28050547,14.4557578 L-1.36009065,6.81516171 Z","transform":"rotate(45 5.047 8.047)","key":1})]);
}

ButtonArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","role":"img"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
